var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DividedList',{attrs:{"data-testid":"meeting-document-list","items":_vm.items,"list-item":_vm.MeetingDocumentListItem,"empty-message":_vm.$t('no_documents_existing')}})
}
var staticRenderFns = []

export { render, staticRenderFns }